import type {Content} from './types';

// Match the article overview: explicit translation groups first, then an
// unambiguous legacy DA/EN slug pair. Never combine different resources.
export function calendarDrafts(items: Content[], kind: Content['kind']): Content[] {
  const selected = items.filter(item => item.kind === kind);
  if (kind === 'social') return selected;
  const groups = new Map<string, Content[]>();
  const groupKey = (item: Content) => JSON.stringify([item.source, item.resourceId, item.translationGroupId || item.id]);
  for (const item of selected) {
    const key = groupKey(item);
    groups.set(key, [...(groups.get(key) || []), item]);
  }
  const slugs = new Map<string, Content[]>();
  for (const item of selected) {
    if (item.source !== 'legacy' || !item.slug) continue;
    const key = JSON.stringify([item.resourceId, item.slug]);
    slugs.set(key, [...(slugs.get(key) || []), item]);
  }
  for (const pair of slugs.values()) {
    if (pair.length !== 2 || !pair.some(item => item.locale === 'da') || !pair.some(item => item.locale === 'en')) continue;
    if (pair.some(item => groups.get(groupKey(item))?.length !== 1)) continue;
    pair.forEach(item => groups.delete(groupKey(item)));
    groups.set(groupKey(pair[0]), pair);
  }
  return [...groups.values()].map(group => group.find(item => item.locale === 'da') || group.find(item => item.locale === 'en') || group[0]);
}
